export default () => {
    const body = document.body;
    const html = document.documentElement;
    const top = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );
    window.scrollTo({ top });
};
